import { useEffect, useState } from 'react';
import axios from 'axios';
const STUDIO_MAP_EMBED = 'https://smalltownsitaly.theexpatstudio.com/api/public/map/embed';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let countriesPromise = null;
const loadCountries = () => {
  if (!countriesPromise) countriesPromise = axios.get(`${API}/guides`).then((r) => Array.from(new Set((r.data.guides || []).map((g) => g.country || 'Italy'))).sort()).catch(() => []);
  return countriesPromise;
};

export const useSeriesCountries = () => {
  const [countries, setCountries] = useState([]);
  useEffect(() => { loadCountries().then(setCountries); }, []);
  return countries;
};

const Pill = ({ active, onClick, children, testId, dark }) => (
  <button type="button" onClick={onClick} data-testid={testId} aria-pressed={active}
    className={`px-4 py-1.5 rounded-full text-sm border transition-colors duration-200 ${active ? 'bg-[#C5A059] border-[#C5A059] text-[#2D1037]' : dark ? 'border-white/25 text-[#FAF7F2]/80 hover:border-[#C5A059]' : 'border-[#E6DAC5] text-[#1E1622]/70 bg-white hover:border-[#C5A059]'}`}>
    {children}
  </button>
);

export const CountryMap = ({ testPrefix, className = 'block w-full h-[360px] md:h-[520px] border-0', dark = false }) => {
  const countries = useSeriesCountries();
  const [country, setCountry] = useState('');
  const src = country ? `${STUDIO_MAP_EMBED}?country=${encodeURIComponent(country)}` : STUDIO_MAP_EMBED;
  return (
    <>
      {countries.length > 1 && (
        <div className={`flex flex-wrap justify-center gap-2 px-4 py-3 ${dark ? 'bg-[#2D1037]' : ''}`} data-testid={`${testPrefix}-country-filter`}>
          <Pill dark={dark} active={!country} onClick={() => setCountry('')} testId={`${testPrefix}-country-all`}>All countries</Pill>
          {countries.map((c) => <Pill key={c} dark={dark} active={country === c} onClick={() => setCountry(c)} testId={`${testPrefix}-country-${c.toLowerCase()}`}>{c}</Pill>)}
        </div>
      )}
      <iframe key={src} src={src} title={`Small Towns Series map${country ? ` – ${country}` : ''}`} loading="lazy" data-testid={`${testPrefix}-iframe`} className={className} />
    </>
  );
};
